import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhoneOutlineUpper = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 400,
	height: 426,
	viewBox: "0 0 400 426",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_39_8653)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				x: 22,
				y: 46.0498,
				width: 358.855,
				height: 726.712,
				rx: 38.99,
				stroke: "url(#paint0_linear_39_8653)",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 163.832,
				y: 67.751,
				width: 50.1174,
				height: 10.1363,
				rx: 3.87,
				stroke: "url(#paint1_linear_39_8653)",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M227.288 78.5715C230.476 78.5715 233.061 75.996 233.061 72.8189C233.061 69.6419 230.476 67.0664 227.288 67.0664C224.099 67.0664 221.515 69.6419 221.515 72.8189C221.515 75.996 224.099 78.5715 227.288 78.5715Z",
				stroke: "url(#paint2_linear_39_8653)",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M327.506 64.9834H286.427V69.9425C286.421 82.8549 275.915 93.3195 262.956 93.3195H131.984C119.025 93.3195 108.518 82.8549 108.513 69.9425V64.9834H69.9714C54.2325 64.9834 41.4736 77.6966 41.4736 93.379V725.443C41.4736 741.125 54.2325 753.838 69.9714 753.838H327.506C343.245 753.838 356.004 741.125 356.004 725.443V93.379C356.004 77.6966 343.245 64.9834 327.506 64.9834Z",
				stroke: "url(#paint3_linear_39_8653)",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsxs("g", {
				filter: "url(#filter0_d_39_8653)",
				children: [/* @__PURE__ */ _jsx("rect", {
					x: 76,
					y: 140,
					width: 250,
					height: 249.998,
					rx: 19.4634,
					fill: "url(#paint4_linear_39_8653)",
					fillOpacity: .21,
					shapeRendering: "crispEdges"
				}), /* @__PURE__ */ _jsx("rect", {
					x: 75.25,
					y: 139.25,
					width: 251.5,
					height: 251.498,
					rx: 20.2134,
					stroke: "url(#paint5_linear_39_8653)",
					strokeWidth: 1.5,
					shapeRendering: "crispEdges"
				})]
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M122.927 151.692H94.6149C91.9275 151.692 89.749 153.87 89.749 156.557V184.869",
				stroke: "url(#paint6_linear_39_8653)",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M89.749 345.128L89.749 373.44C89.749 376.127 91.9275 378.306 94.6149 378.306L122.927 378.306",
				stroke: "url(#paint7_linear_39_8653)",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M278.736 378.306L307.047 378.306C309.735 378.306 311.913 376.127 311.913 373.44L311.913 345.128",
				stroke: "url(#paint8_linear_39_8653)",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M311.913 184.869L311.913 156.557C311.913 153.87 309.735 151.692 307.047 151.692L278.736 151.692",
				stroke: "url(#paint9_linear_39_8653)",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_39_8653",
			x: 70.5,
			y: 136.5,
			width: 261,
			height: 260.998,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_39_8653"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_39_8653",
					result: "shape"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_39_8653",
			x1: 326.376,
			y1: 563.336,
			x2: 8.74198,
			y2: 467.917,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FE0368" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FF472C"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_39_8653",
			x1: 206.341,
			y1: 74.9662,
			x2: 201.527,
			y2: 60.4875,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FE0368" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FF472C"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint2_linear_39_8653",
			x1: 231.308,
			y1: 75.2559,
			x2: 223.191,
			y2: 70.3003,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FE0368" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FF472C"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint3_linear_39_8653",
			x1: 308.254,
			y1: 555.322,
			x2: 26.4708,
			y2: 477.051,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FE0368" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FF472C"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint4_linear_39_8653",
			x1: 76,
			y1: 140,
			x2: 204.13,
			y2: 441.747,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "white",
				stopOpacity: .49
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "white",
				stopOpacity: .4
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint5_linear_39_8653",
			x1: 288.047,
			y1: 317.953,
			x2: 111.962,
			y2: 210.831,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FE0368" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FF472C"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint6_linear_39_8653",
			x1: 117.89,
			y1: 175.308,
			x2: 94.5215,
			y2: 161.092,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FE0368" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FF472C"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint7_linear_39_8653",
			x1: 113.365,
			y1: 350.165,
			x2: 99.1493,
			y2: 373.533,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FE0368" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FF472C"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint8_linear_39_8653",
			x1: 283.772,
			y1: 354.689,
			x2: 307.141,
			y2: 368.906,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FE0368" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FF472C"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint9_linear_39_8653",
			x1: 288.297,
			y1: 179.832,
			x2: 302.513,
			y2: 156.464,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FE0368" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FF472C"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_39_8653",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 400,
				height: 426,
				rx: 4,
				fill: "white"
			})
		})
	] })]
});
export { SvgPhoneOutlineUpper as ReactComponent };
